export default {
    apiKey: "AIzaSyDbg8pYCLmzbMwXsQ3Ua5zFbRdJTa4sPXU",
    apiKey: "AIzaSyC6S1wqc7pjvpXtrIeQK0UHdTNcMchhWa0",
    authDomain: "caav-storage.firebaseapp.com",
    projectId: "caav-storage",
    storageBucket: "caav-storage.appspot.com",
    messagingSenderId: "537406961089",
    appId: "1:537406961089:web:14adbd4e44f774ccfdab40",
    measurementId: "G-RYQD6328LW"
};